<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="50%" @open="addOpen" :close-on-click-modal="false">
    <el-table :data="picList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
      <el-table-column label="Url" align="center">
        <template slot-scope="scope">
          <el-image :src="scope.row.url"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[5, 10, 20, 30, 40]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </el-dialog>
</template>

<script>
export default {
  name: 'handpick_article_pic_list',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '文章图片列表',
      picList: [],
      total: 0,
      pageTotal: 1,
      param: {
        article_id: 0,
        page: 1,
        count: 5
      }
    }
  },
  methods: {
    closeDialog () {
      this.picList = []
      this.total = 0
      this.pageTotal = 1
      this.$emit('closeDialog')
    },
    addOpen () {
      this.param.article_id = this.id
      this.getArticlePicList()
    },
    async getArticlePicList (id) {
      const res = await this.$http.get('/admin/handpick_article/pic_list', this.param)
      if (res.code === 0) {
        this.picList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getArticlePicList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getArticlePicList()
    }
  }
}
</script>

<style scoped>
</style>
